export default {"src":"/_next/static/media/yellow-blue-flowers.0cd5f625.svg","height":105,"width":115,"blurWidth":0,"blurHeight":0};